import { Component, Input, ViewChild } from '@angular/core'
import { ModalDirective } from 'ng2-bootstrap/src/modal'

@Component({
  template:`
    <div class="modal fade" bsModal #modal="bs-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header" *ngIf="title">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>

          <div class="modal-body" [innerHTML]="comment">
          </div>

          <div class="modal-footer">
            <div class="pull-left buttons">
              <button type="button" class="btn btn-success btn_width_108" (click)="modal.hide()">ОК</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  selector: 'modal-static-text'
})

export class ModalStaticTextComponent {
  @ViewChild('modal') private modal: ModalDirective

  title: string
  comment: string

  show(title: string, comment: string) {
    this.title = title
    this.comment = comment

    this.modal.show()
  }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/forms/modal-static-text.component.ts